import { createStore } from 'owa-satcheljs';

export enum CopilotCatchUpState {
    NotStarted,
    Pending,
    Generating,
    Completed,
    Error,
}

interface CopilotCatchUpStore {
    catchUpState: CopilotCatchUpState;
    highPriorityRowsCount: number;
    needsReplyRowsCount: number;
    needsActionRowsCount: number;
    needsScheduleCountViewState: CopilotCatchUpState;
    needsScheduleRowsCount: number;
    summaryText: string;
    summaryState: CopilotCatchUpState;
}

const getStore: () => CopilotCatchUpStore = createStore<CopilotCatchUpStore>(
    'CopilotCatchUpStore',
    {
        catchUpState: CopilotCatchUpState.NotStarted,
        highPriorityRowsCount: 0,
        needsReplyRowsCount: 0,
        needsActionRowsCount: 0,
        needsScheduleCountViewState: CopilotCatchUpState.NotStarted,
        needsScheduleRowsCount: 0,
        summaryText: '',
        summaryState: CopilotCatchUpState.NotStarted,
    }
);

export default getStore;
